import styled from 'styled-components'

/**
 * Styled components are used in order to style Title component. Props are passed through ThemeProvider.
 */
export const TitleStyle = styled.div<{
  subtitle: boolean
}>`
  ${(props) =>
    !props.subtitle &&
    `
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
  `}
  justify-content: center;
  color: ${(props) =>
    props.subtitle
      ? props.theme.subtitleColor || props.theme.colors?.secondary || '#ffffff'
      : props.theme.titleColor || props.theme.colors?.primary};
  font-size: ${(props) =>
    !props.subtitle
      ? 1 || props.theme.titleFontSize || props.theme.fontSize
      : props.theme.subtitleFontSize || props.theme.fontSize || 1}em;
  font-family: ${(props) => props.theme.fontFamily};
  margin: 0.5em 0em 0.5em 0em;
`
